import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29be1462&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29be1462')) {
      api.createRecord('29be1462', component.options)
    } else {
      api.reload('29be1462', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29be1462&", function () {
      api.rerender('29be1462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/LangSelect/index.vue"
export default component.exports